import { Notifications, Reminder, ReminderBasedOn } from '@griply/types';

import {
  DEFAULT_ALL_DAY_REMINDER_OFFSET_MS,
  DEFAULT_PLANNED_REMINDER_OFFSET_MS,
} from './get-reminder-options';

// Mirrors the backend: a number is the chosen offset, null is "off", undefined falls back to its default.
export const getDefaultTaskReminder = (
  notifications: Notifications | undefined,
  basedOn: ReminderBasedOn,
): Reminder | null => {
  const isTimed = basedOn === ReminderBasedOn.Start;
  const time = isTimed
    ? notifications?.plannedTask?.time
    : notifications?.allDayTask?.time;

  if (time === null) {
    return null;
  }

  const offset =
    typeof time === 'number'
      ? time
      : isTimed
        ? DEFAULT_PLANNED_REMINDER_OFFSET_MS
        : DEFAULT_ALL_DAY_REMINDER_OFFSET_MS;

  return { id: null, offset, basedOn };
};
